module.exports = __webpack_public_path__ + "media/images/icons/twitter-106778eeae3bcde4aa3b7ca0de922472.svg";